type TParams = {
  isNew: boolean;
  hasJob: boolean;
  isJobError: boolean;
  hasMediaFiles: boolean;
  isMediaFilesError: boolean;
};

export const hasExistingJobLoadFailed = ({
  isNew,
  hasJob,
  isJobError,
  hasMediaFiles,
  isMediaFilesError,
}: TParams): boolean => !isNew && ((!hasJob && isJobError) || (!hasMediaFiles && isMediaFilesError));
